module.exports = __webpack_public_path__ + "img/AM.18bcdd59.svg";